import { render, staticRenderFns } from "./CustomAddress.vue?vue&type=template&id=b2adf842&scoped=true&lang=html&"
import script from "./CustomAddress.vue?vue&type=script&lang=js&"
export * from "./CustomAddress.vue?vue&type=script&lang=js&"
import style0 from "./CustomAddress.vue?vue&type=style&index=0&id=b2adf842&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2adf842",
  null
  
)

export default component.exports